import { render, staticRenderFns } from "./FactureClient.vue?vue&type=template&id=d35566a4&"
import script from "./FactureClient.vue?vue&type=script&lang=js&"
export * from "./FactureClient.vue?vue&type=script&lang=js&"
import style0 from "./FactureClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports